import React from 'react';
import { Box, Chip, Rating, Stack, Typography } from '@mui/material';
import { SiteConditionsSummary } from '../services/postService';
import { OptionsManager } from '../utils/optionsManager';
import { formatVisibility, formatWaterTemp, timeAgo } from '../utils/conditions';

/** "Recent conditions" for a site: medians of the last two weeks of Public reports, with how fresh they are. */
const SiteConditionsSummaryCard: React.FC<{ summary: SiteConditionsSummary }> = ({ summary }) => {
  const units = OptionsManager.getInstance().getOption('units');

  if (summary.reportCount === 0) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Recent conditions</Typography>
        <Typography variant="body2" color="text.secondary">
          No reports in the last {summary.windowDays} days. Been here lately? Add one.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Recent conditions</Typography>
      <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1} alignItems="center" sx={{ my: 1 }}>
        {summary.medianVisibilityMeters != null && <Chip size="small" label={`Visibility ~${formatVisibility(summary.medianVisibilityMeters, units.depth)}`} />}
        {summary.medianWaterTemperatureC != null && <Chip size="small" label={`Water ~${formatWaterTemp(summary.medianWaterTemperatureC, units.temperature)}`} />}
        {summary.mostCommonCurrent && <Chip size="small" label={`${summary.mostCommonCurrent} current`} />}
        {summary.averageRating != null && (
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Rating value={summary.averageRating} precision={0.5} readOnly size="small" />
            <Typography variant="caption" color="text.secondary">{summary.averageRating.toFixed(1)}</Typography>
          </Stack>
        )}
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
        From {summary.reportCount} report{summary.reportCount === 1 ? '' : 's'} in the last {summary.windowDays} days
        {summary.latestReportAt ? ` · latest ${timeAgo(summary.latestReportAt)}` : ''}. Other divers' opinions, not a dive briefing.
      </Typography>
    </Box>
  );
};

export default SiteConditionsSummaryCard;
